module.exports = __webpack_public_path__ + "static/hospital_icon-cc426e979607885b19e0ae348f456c41.svg";